<div class="card new-card">
    <app-card-title title="Opcionais" icon="app-icon-in-stock"></app-card-title>
    <div class="col-md-12 equipments">
        <div class="row">
            <div class="col-md-6 col-sm-12 equipment" *ngFor="let equipment of equipments">
                <i class="material-icons">check</i>{{equipment | titlecase}}
            </div>
        </div>
    </div>
</div>